var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndependant07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0122 22.5V36.0251C12.0122 36.8328 12.0122 37.2366 12.1352 37.5931C12.2439 37.9084 12.4214 38.1956 12.6548 38.4338C12.9187 38.7032 13.2799 38.8839 14.0022 39.245L26.1522 45.32C26.7425 45.6152 27.0377 45.7628 27.3473 45.8209C27.6215 45.8723 27.9029 45.8723 28.1771 45.8209C28.4867 45.7628 28.7819 45.6152 29.3722 45.32L41.5222 39.245C42.2446 38.8838 42.6058 38.7032 42.8696 38.4338C43.103 38.1956 43.2805 37.9084 43.3892 37.5931C43.5122 37.2366 43.5122 36.8328 43.5122 36.0251V22.5M5.26221 19.125L26.9572 8.27752C27.2524 8.12994 27.4 8.05615 27.5548 8.0271C27.6919 8.00138 27.8326 8.00138 27.9697 8.0271C28.1245 8.05615 28.272 8.12994 28.5672 8.27752L50.2622 19.125L28.5672 29.9725C28.272 30.1201 28.1245 30.1939 27.9697 30.2229C27.8326 30.2487 27.6919 30.2487 27.5548 30.2229C27.4 30.1939 27.2524 30.1201 26.9572 29.9725L5.26221 19.125Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndependant07);
export default __webpack_public_path__ + "static/media/independant07.2319282065f438f1a04f0b19758e65e8.svg";
export { ForwardRef as ReactComponent };